const GO_LOGIN = 'GO_LOGIN';
const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
const SET_REFRESH_ACCESS_TOKEN = 'SET_REFRESH_ACCESS_TOKEN';
const SET_LOGIN = 'SET_LOGIN';
const SET_PROFILE = 'SET_PROFILE';
const SET_SAVED_CREDENTIALS = 'SET_SAVED_CREDENTIALS';

export { GO_LOGIN, SET_ACCESS_TOKEN, SET_REFRESH_ACCESS_TOKEN, SET_LOGIN, SET_PROFILE, SET_SAVED_CREDENTIALS };
